import { InventoryManagementAuctionItemStatus, InventoryManagementSortOptions, InventoryManagementSortOrder } from 'remarketing-angular-library';
import { SellSort } from 'remarketing-angular-library';

export function isValidSellSortEnum(value: any): value is SellSort {
  return Object.values(SellSort).includes(value);
}


export function sellSortFromParams(sortBy = '', sortOrder = ''): SellSort | undefined {
  const sortValue = `${sortBy}__${sortOrder}`.toUpperCase();
  return isValidSellSortEnum(sortValue) ? sortValue : undefined;
}

export function searchParamsFromSellSort(value: SellSort): { sortBy: string; sortOrder: string } | undefined {
  if (!isValidSellSortEnum(value)) {
    return undefined;
  }
  const [sortBy, sortOrder] = value.split('__');
  return { sortBy, sortOrder };
}


export function defaultSortForStatus(status: InventoryManagementAuctionItemStatus): SellSort {
  let defaultSort: SellSort;
  switch (status) {
  case InventoryManagementAuctionItemStatus.SOLD:
    defaultSort = SellSort.SOLD_DATE__DESC;
    break;
  case InventoryManagementAuctionItemStatus.HOLD:
    defaultSort = SellSort.HOLD_DAYS__DESC;
    break;
  case InventoryManagementAuctionItemStatus.REMOVED:
    defaultSort = SellSort.STATUS_CHANGED_DATE__DESC;
    break;
  case null:
    defaultSort = SellSort.STATUS_CHANGED_DATE__DESC;
    break;
  case InventoryManagementAuctionItemStatus.ACTIVE:
  default:
    defaultSort = SellSort.STATUS;
    break;
  }
  return defaultSort;
}
